import { db } from './firebase';
import { 
  collection, 
  addDoc, 
  query, 
  where, 
  orderBy, 
  getDocs,
  serverTimestamp,
  Timestamp 
} from 'firebase/firestore';

export const checkInService = {
  // Registrar una checada
  async checkIn(userId, tipo, ubicacion = null) {
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const isInside = Boolean(ubicacion && ubicacion.withinGeofence);

      const checkInData = {
        userId,
        tipo, // 'entrada', 'salida_comida', 'entrada_comida', 'salida'
        timestamp: serverTimestamp(),
        fecha: Timestamp.fromDate(today),
        ubicacion: ubicacion ? {
          latitude: ubicacion.latitude ?? null,
          longitude: ubicacion.longitude ?? null,
          distance: ubicacion.distance ?? null,
          withinGeofence: isInside,
          sucursalNombre: ubicacion.sucursalNombre || 'Sucursal',
          fueraDeSucursal: !isInside
        } : null,
        fueraDeSucursal: !isInside,
        verificacionFacial: true
      };

      const docRef = await addDoc(collection(db, 'checadas'), checkInData);
      return { 
        success: true, 
        id: docRef.id,
        isInside,
        message: this.getMensajeConfirmacion(tipo, isInside)
      };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Obtener la última checada del día para un usuario
  async getLastCheckIn(userId) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const q = query(
      collection(db, 'checadas'),
      where('userId', '==', userId),
      where('fecha', '>=', Timestamp.fromDate(today)),
      where('fecha', '<', Timestamp.fromDate(tomorrow)),
      orderBy('fecha', 'desc'),
      orderBy('timestamp', 'desc')
    );

    const snapshot = await getDocs(q);
    return snapshot.empty ? null : snapshot.docs[0].data();
  },

  // Obtener checadas de un usuario en un rango de fechas
  async getUserCheckIns(userId, fechaInicio, fechaFin) {
    try {
      const q = query(
        collection(db, 'checadas'),
        where('userId', '==', userId),
        where('timestamp', '>=', fechaInicio),
        where('timestamp', '<=', fechaFin),
        orderBy('timestamp', 'desc')
      );

      const snapshot = await getDocs(q);
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        timestamp: doc.data().timestamp?.toDate()
      }));
    } catch (error) {
      throw error;
    }
  },

  getMensajeConfirmacion(tipo, dentroDeSucursal = true) {
    const sufijo = dentroDeSucursal ? ' correctamente' : ' (⚠️ Fuera de sucursal)';
    const mensajes = {
      'entrada': `🚪 Entrada registrada${sufijo}`,
      'salida_comida': `🍽️ Salida a comida registrada${sufijo}`,
      'entrada_comida': `🔙 Regreso de comida registrado${sufijo}`,
      'salida': `🏠 Salida registrada${sufijo}`
    };
    return mensajes[tipo] || `Checada registrada${sufijo}`;
  }
};